import React, { useState } from 'react';

import DeprecatedDropdown from '../../../../deprecated/DeprecatedDropdown/DeprecatedDropdown';
import DropdownItem from '../../../../deprecated/DeprecatedDropdown/DeprecatedDropdownItem/DeprecatedDropdownItem';
import RadioOption from '../../../Radio/RadioOption/RadioOption';

import isFilterSelected from '../../helpers/filters/isFilterSelected';
import Button from '../../../Button/Button';
import HStack from '../../../HStack/HStack';

const Filter = ({ groups, onChange, id }) => {
  const [selected, setSelected] = useState(groups);

  const clearSelected = () => {
    const newSelected = selected.map(group => {
      const uncheckedItems = group.items.map(item => ({ ...item, checked: false }));
      return { ...group, items: uncheckedItems };
    });

    setSelected(newSelected);
    onChange(newSelected);
  };

  const handleChange = (groupLabel, itemLabel) => {
    const newSelected = selected.map(group => {
      if (group.label !== groupLabel) return group;
      const items = group.items.map(item => {
        if (item.label !== itemLabel) {
          return { ...item, checked: false };
        }
        return { ...item, checked: !item.checked };
      });
      return { ...group, items };
    });

    setSelected(newSelected);
    onChange(newSelected);
  };

  const renderClearFilters = () => {
    if (isFilterSelected(selected)) {
      return (
        <Button type="link" onClick={clearSelected}>
          Clear filters
        </Button>
      );
    }
    return null;
  };

  const renderItems = group => {
    const radioName = `ledger-filter-${id}-${group.label}`;
    return group.items.map(item => {
      const customId = `ledger-filter-${id}-${group.label}-${item.label}`;
      return (
        <DropdownItem key={customId}>
          <RadioOption
            id={customId}
            label={item.label}
            value={item.value}
            name={radioName}
            isChecked={item.checked}
            onChange={() => handleChange(group.label, item.label)}
            isFieldless
          />
        </DropdownItem>
      );
    });
  };

  const renderContent = () =>
    selected.map(group => (
      <React.Fragment key={`ledger-filter-${id}-${group.label}`}>
        <DropdownItem isHeader>{group.label}</DropdownItem>
        {renderItems(group)}
      </React.Fragment>
    ));

  return (
    <HStack spacing="medium">
      <DeprecatedDropdown trigger="Filter" hasArrow preventClose>
        {renderContent()}
      </DeprecatedDropdown>
      {renderClearFilters()}
    </HStack>
  );
};

export default Filter;
